export default __webpack_public_path__ + "static/media/bg-border.73748bb8.svg";